import * as React from "react";
import { SVGProps } from "react";

export const CircleArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      stroke={props.color}
      strokeWidth={2}
      d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z"
    />
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8 10 3.87 4.373a.174.174 0 0 0 .26 0L16 10"
    />
  </svg>
);
export default CircleArrowDown;
